import { permissionProfiles } from "components/Authorize/permissionProfiles";
import { TabsWrapper } from "components/TabsWrapper/TabsWrapper";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import configStyles from "../configStyles";
import LotsConfigStyle from "./LotsConfigStyle";
import Emails from "./components/Emails";
import Lots from "./components/Lots";
import Pricing from "./components/Pricing";
import VehicleStatuses from "./components/VehicleStatuses";
import {
    resetBulkUpdate,
} from "./lotConfigSlice";

const useStyles = LotsConfigStyle;
const useConfigStyles = configStyles;

export const clientLotConfigModel = {
    pricePerSpot: 0,
    overage: 0,
    numberOfSpots: 0,
    clientAlias: ''
}

const LotsConfig = ({ clientToEdit, onConfigChange }) => {
    const configClasses = useConfigStyles();
    const classes = useStyles();

    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(resetBulkUpdate());
        }
    }, []);



    const tabs = [
        {
            label: 'Lots',
            component: <Lots clientToEdit={clientToEdit} />
        },
        {
            label: 'Invoicing & Reports',
            component: <Pricing clientToEdit={clientToEdit} onConfigChange={onConfigChange} />
        },
        {
            label: 'Statuses',
            component: <VehicleStatuses clientId={clientToEdit?.id} />
        },
        {
            label: 'Emails',
            component: <Emails clientId={clientToEdit?.id} />,
            permission: permissionProfiles.CLIENT_CONFIG.CLIENT_CONFIG_LOT_PRICING
        }
    ]

    return (
        <>
            <TabsWrapper tabs={tabs} />
        </>
    )
}
export default LotsConfig;
